import { getDocumentUploadFieldName } from 'components/MyTaskArea/utils/mapTaskDetail';

export const getTaskDetailUploadFiles = (values, fileId) => {
  const fieldValue = values[getDocumentUploadFieldName(fileId)];
  if (!Array.isArray(fieldValue)) {
    return [];
  }
  return fieldValue;
};

export const collectTaskDetailFilesToUpload = (fileEntries, values) =>
  fileEntries.flatMap((fileEntry) => {
    const uploaded = values[getDocumentUploadFieldName(fileEntry.id)];
    if (!Array.isArray(uploaded)) {
      return [];
    }
    return uploaded.map((file) => ({ documentType: fileEntry.documentType, file }));
  });
